// инструменты для формирования @mui/x-tree-view из представления v_entity_path

import { TreeViewBaseItem } from '@mui/x-tree-view/models';
import { EntityPath } from '../../types/plate';

const CompareArray = (a: number[], b: number[]) => {
  for (let i = 0; i < Math.min(a.length, b.length); i++) {
    if (a[i] !== b[i]) {
      return a[i] - b[i];
    }
  }
  return a.length - b.length;
};

export const makeTreeItems = (entityPaths: EntityPath[]): TreeViewBaseItem[] => {
  // 1. Сортируем элементы
  // Сортировка по path_ids гарантирует, что мы обработаем родителя до его потомков.
  const sorted = [...entityPaths].sort((a, b) => CompareArray(a.path_ids, b.path_ids));

  // Карта для быстрого доступа к узлам дерева по их ID (entity_id)
  const map: Record<string, TreeViewBaseItem> = {};
  
  // Массив для хранения элементов верхнего уровня
  const treeItems: TreeViewBaseItem[] = [];

  sorted.forEach(ep => {
    // Создаем новый элемент дерева
    const newItem: TreeViewBaseItem = {
      id: String(ep.entity_id), // Используем entity_id как строковый ID узла
      label: ep.name,
      // originalData: ep, // Можно добавить исходный объект для удобства
    };

    // Добавляем элемент в карту
    map[newItem.id] = newItem;

    // Определяем родительский path_id
    const parentPathIds = ep.path_ids.slice(0, ep.path_ids.length - 1);
    
    if (parentPathIds.length === 0) {
      // Это элемент верхнего уровня (depth 1)
      treeItems.push(newItem);
    } else {
      // Находим родительский entity_id. Это последний элемент родительского path_ids.
      const parentEntityId = parentPathIds[parentPathIds.length - 1];
      const parentNodeId = String(parentEntityId);
      
      const parentNode = map[parentNodeId];
      
      if (parentNode) {
        // Добавляем текущий элемент как дочерний к найденному родителю
        if (!parentNode.children) {
          parentNode.children = [];
        }
        parentNode.children.push(newItem);
      } 
      // Примечание: Если родитель не найден, это означает, что исходные данные
      // могут быть неполными или неправильно отсортированными.
      // Однако, благодаря сортировке, мы ожидаем, что родитель уже был обработан.
    }
  });

  return treeItems;
};